var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("Copyright © 2023 天津拂云科技有限公司")]),_c('p',[_vm._v("津ICP备2022009798号-2")]),_c('p',[_c('a',{attrs:{"href":"https://accessview.tjfytech.com/protocol.html","target":"_blank"}},[_vm._v("用户协议")]),_c('span',[_vm._v("|")]),_c('a',{attrs:{"href":"https://accessview.tjfytech.com/privacy.html","target":"_blank"}},[_vm._v("隐私政策")])])])
}]

export { render, staticRenderFns }